var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _vm.sendBox === "sms" && !_vm.hideSendBox
        ? _c(
            "sms",
            _vm._b(
              {
                ref: "sendBox",
                on: {
                  "outbound-message-created": _vm.onOutboundMessageCreated,
                },
              },
              "sms",
              _vm.getSmsProps,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.sendBox === "mail" && !_vm.hideSendBox
        ? _c(
            "mail",
            _vm._b(
              {
                ref: "sendBox",
                on: {
                  "outbound-message-created": _vm.onOutboundMessageCreated,
                },
              },
              "mail",
              _vm.getMailProps,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-2" },
        [
          _vm.canSendSms || _vm.canSendApprovedSms
            ? _c(
                "button",
                {
                  staticClass: "btn",
                  class: [_vm.sendBox === "sms" ? "btn-purple" : "btn-default"],
                  attrs: { disabled: !_vm.isPossibleSendSms },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.setSendBox("sms")
                    },
                  },
                },
                [
                  !_vm.contactHasPhoneNumber
                    ? _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: "The contact does not have a phone number",
                            placement: "top",
                            effect: "light",
                          },
                        },
                        [_c("span", [_vm._v("SMS")])]
                      )
                    : _c("span", [_vm._v("SMS")]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canSendEmail
            ? _c(
                "button",
                {
                  staticClass: "btn",
                  class: [
                    _vm.sendBox === "mail" ? "btn-purple" : "btn-default",
                  ],
                  attrs: { disabled: !_vm.isPossibleSendEmail },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.setSendBox("mail")
                    },
                  },
                },
                [
                  !_vm.contactHasEmailAddress
                    ? _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content:
                              "The contact does not have an email address",
                            placement: "top",
                            effect: "light",
                          },
                        },
                        [_c("span", [_vm._v("Email")])]
                      )
                    : _c("span", [_vm._v("Email")]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canMakeCall
            ? _c(
                "OutboundCall",
                {
                  attrs: {
                    conversation: _vm.conversation,
                    customClass: "btn btn-default",
                    disabled: !_vm.isPossibleMakeCall,
                  },
                },
                [
                  !_vm.contactHasPhoneNumber
                    ? _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: "The contact does not have a phone number",
                            placement: "top",
                            effect: "light",
                          },
                        },
                        [_c("i", { staticClass: "fas fa-phone-alt" })]
                      )
                    : _c("i", { staticClass: "fas fa-phone-alt" }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }